import { alertConstants } from '../constants/alert.constants';

export const alertActions = {
    success,
    error,
    clear
};

function success(message) {
    return { type: alertConstants.SUCCESS, message };
}

function error(message) {
    if (message && typeof(message) == 'object') {
        if (message.sessionExpired) {
            // Duplicate 401s from parallel requests are silenced so only a
            // single "session expired" toast is shown. NOOP leaves the alert
            // state untouched (see the reducer's default case).
            if (message.silent) {
                return { type: alertConstants.NOOP };
            }
            return { type: alertConstants.WARNING, message: 'Sua sessão expirou. Por favor, faça login novamente.' };
        }
        message = message.message || 'Erro desconhecido';
    }
    return { type: alertConstants.ERROR, message };
}

function clear() {
    return { type: alertConstants.CLEAR };
}